var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7844 30H6.38714C4.50147 30 3.55862 30 2.8384 29.6488C2.20485 29.3399 1.68977 28.8469 1.36698 28.2407C1 27.5514 1 26.649 1 24.8444V9.37778C1 7.57317 1 6.67085 1.36698 5.98159C1.68977 5.37528 2.20485 4.88234 2.8384 4.57343C3.55862 4.22222 4.50147 4.22222 6.38714 4.22222H25.9155C27.8012 4.22222 28.7441 4.22222 29.4643 4.57343C30.0978 4.88234 30.6129 5.37528 30.9357 5.98159C31.3027 6.67085 31.3027 7.57317 31.3027 9.37778V12.2778M7.73392 1V4.22222M24.5687 1V4.22222M1 10.6667H31.3027M18.6766 17.1113L7.73392 17.1111M12.7844 23.5557L7.73392 23.5556M19.5183 30L22.9273 29.3475C23.2245 29.2906 23.3731 29.2621 23.5117 29.2101C23.6347 29.164 23.7517 29.1041 23.86 29.0317C23.9822 28.9502 24.0893 28.8477 24.3038 28.6425L31.3027 21.9444C32.2324 21.0546 32.2324 19.612 31.3027 18.7222C30.3729 17.8324 28.8655 17.8324 27.9357 18.7222L20.9368 25.4203C20.7223 25.6255 20.6152 25.728 20.5301 25.8449C20.4545 25.9485 20.3919 26.0605 20.3437 26.1783C20.2893 26.3109 20.2595 26.4531 20.2001 26.7375L19.5183 30Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiry);
export default __webpack_public_path__ + "static/media/expiry.df0c3e8d17ac97836ea33be38ece039e.svg";
export { ForwardRef as ReactComponent };